import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

/**
 * 主布局组件
 * 包含侧边栏、顶部导航栏和内容区域
 */
export const Layout = () => {
  const currentYear = new Date().getFullYear();
  const foundedYear = 2026;  // 公司成立年份
  
  // 自动生成：2026 → "2026"；2027 → "2026-2027"
  const copyrightYear = currentYear === foundedYear 
    ? foundedYear 
    : `${foundedYear}-${currentYear}`;

  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      {/* 顶部 Header 粘性定位，占满宽度 */}
      <Header />
      
      <div className="flex flex-1 overflow-hidden">
        {/* 左侧侧边栏 - 固定宽度，不随滚动变化 */}
        <Sidebar />
        
        {/* 右侧主内容区域 - 优化内边距、滚动、内容容器 */}
        <main className="flex-1 overflow-auto bg-gray-50 p-6">
          {/* 内容卡片容器 - 增加白色背景、圆角、阴影，提升页面层次感 */}
          <div className="max-w-7xl mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
      
      {/* 页脚 - 优化样式、文字、间距，与整体风格统一 */}
      <div className="text-center p-4 bg-white text-sm text-gray-500 border-t border-gray-100">
        ©{copyrightYear} 深圳轻智云创新物联科技有限公司 版权所有
        <span className="mx-3">|</span>
        <a 
          href="https://beian.miit.gov.cn/#/Integrated/index" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-gray-500 hover:text-blue-600 no-underline transition-colors"
        >
          粤ICP备2026011563号-2
        </a>
      </div>
    </div>
  );
};